<template>
  <button
    @click="onClick"
    title="Gem rute"
  >
    <save-icon />
  </button>
</template>

<script>
import SaveIcon from '@/components/Icons/Save.vue';
export default {
  name: 'save-button',
  components: { SaveIcon },
  props: { onClick: Function },
};
</script>

<style lang="scss" scoped>
button {
  position: absolute;
  bottom: 33px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 92px;
  height: 92px;
  border-radius: 100%;
  background-color: #bb5cee;
  box-shadow: 0 5px 15px 0 rgba(121, 27, 165, 0.49);
  border: none;
  cursor: pointer;
  z-index: 11;
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  button {
    margin-right: -46px;
    bottom: 50px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  button {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    position: fixed;
    bottom: 35px;
    svg {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
